export function set(key: string, data: any, expire: number) {
  if (!key) return
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  } else if (typeof data === 'number') {
    data = String(data)
  } else if (typeof data === 'boolean') {
    // 布尔值可以保持原样或转换为字符串
    data = String(data)
  }
  let time = 0
  if (expire && /\d+/.test(expire + '')) {
    let now = new Date().getTime()
    time = now + expire
  }

  localStorage.setItem(
    key,
    JSON.stringify({
      data,
      expire: time
    })
  )
}

export function get<T>(key: string): T | null {
  if (!key) return null
  let data = null
  let storage = localStorage.getItem(key)

  if (storage) {
    try {
      let res = JSON.parse(storage)
      if (_checkExpire(res.expire)) {
        // 修复：先检查 data 的类型，再决定如何处理
        if (typeof res.data === 'string') {
          // 只有字符串才需要检查是否是 JSON
          if (res.data.indexOf('{') === 0 || res.data.indexOf('[') === 0) {
            try {
              data = JSON.parse(res.data)
            } catch (e) {
              data = res.data
            }
          } else {
            data = res.data
          }
        } else {
          // 如果不是字符串（如数字、布尔值、对象、数组），直接使用
          data = res.data
        }
      } else {
        localStorage.removeItem(key)
      }
    } catch (err) {
      data = null
    }
  }
  return data
}

function _checkExpire(expire: number) {
  if (expire <= 0) {
    return true
  }
  return Number(expire) - new Date().getTime() > 1000
}

export function remove(key: string) {
  if (!key) return
  localStorage.removeItem(key)
}
